import React, { useState, useEffect } from "react";
import Navbar from "../../../Navbar";
import { useParams } from "react-router-dom";
import {
    Box,
} from "@mui/material";
import { CircularProgress } from "@mui/material";

import FactibilidadDetalle from "./FactibilidadDetalle";
import AccesoDenegado from "../../../AccesoDenegado"
import { UrlApi } from "../../../../services/apirest";
import { getDataIx0 } from "../../../../services/library";
import { useNavigate } from "react-router-dom";


export default function FactibilidadContainer() {
    const [accesoPermitido, setAccesoPermitido] = useState(null);
    const currentUser = {
        usuario: localStorage.getItem("user"),
        sector: localStorage.getItem("sector"),
        rol: localStorage.getItem("role")
    }
    const { uuidfact } = useParams();
    const [factibilidad, setFactibilidad] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [domicilio, setDomicilio] = useState(null);
    const [artefactos, setArtefactos] = useState(null);
    const [precios, setPrecios] = useState(null);
    const [muestraForm, setMuestraForm]=useState();
    const [factConfig, setFactConfig]=useState();
    const navigate = useNavigate();

    const permitirAcceso = () => { //Si es el comercial que cargó la factibilidad
        if (currentUser.usuario === factibilidad.usuario_registra) {
            setAccesoPermitido(true);
            return;
        }

        if (currentUser.rol === "admin" && (currentUser.sector == "5" || currentUser.sector == 13)) {
            setAccesoPermitido(true);
            setMuestraForm(currentUser.sector === "5")
            return;
        }
        
        setAccesoPermitido(false);
    }

    const getDataFactibilidad = async () => {
        try {
            const response = await fetch(`${UrlApi}/factibilidades/uuid/${uuidfact}`);
            const data = await response.json();
            setFactibilidad(data[0]);
        } catch (error) {
            console.error("Error al obtener el cliente:", error);
        }
    };


    const getDataCliente = async (tipoFactibilidad) => {
        const ruta = tipoFactibilidad === 235 ? `${UrlApi}/clientes/uuid/${uuidfact}` : `${UrlApi}/clientes/${factibilidad?.id_cliente_ampliacion}`
        try {
            const response = await fetch(ruta);
            const data = await response.json();
            setCliente(data[0]);
        } catch (error) {
            console.error("Error al obtener el cliente:", error);
        }
    };

    const getDataDomicilio = async (tipoFactibilidad) => {
        const ruta = tipoFactibilidad === 235 || tipoFactibilidad === 237 ? `${UrlApi}/direccionesentrega/uuid/${uuidfact}` : `${UrlApi}/direccionesentrega/factibilidades/id/${factibilidad.id_domicilio_ampliacion}`;
        try {
            const response = await fetch(ruta);
            const data = await response.json();
            setDomicilio(data[0]);
        } catch (error) {
            console.error("Error al obtener el domicilio:", error);
        }
    };

    const getDataArtefactos = async () => {
        try {
            const response = await fetch(`${UrlApi}/fact_artefactos/${uuidfact}`);
            const data = await response.json();
            setArtefactos(data);
        } catch (error) {
            console.error("Error al obtener el artefacto:", error);
        }
    };

    /* ---------------------------------------- EFFECTS ---------------------------------------- */

    useEffect(() => {
        getDataFactibilidad();
        getDataArtefactos();
    }, [uuidfact]);

    useEffect(() => {
        if (!!factibilidad?.id_tipofact) {
            getDataCliente(factibilidad?.id_tipofact);
            getDataDomicilio(factibilidad?.id_tipofact);
        }
        factibilidad && permitirAcceso();
    }, [factibilidad])

    useEffect(() => {
        if (!!domicilio?.id_producto && cliente) {
            getDataIx0(
                `/lista_precios/fechavigente/${cliente.id_empresa}/${cliente.id_sucursal}/${cliente.id_segmento}/${domicilio.id_producto}`,
                setPrecios
            );
        }
    }, [domicilio, cliente]);

    return (
        <div>
            <Navbar />
            {
                accesoPermitido === null ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <CircularProgress />
                    </Box>
                ) : accesoPermitido === false ? (
                    <AccesoDenegado onGoBack={() => navigate('/navbar')} />
                ) : (
                    <>
                        {factibilidad && cliente && domicilio && artefactos && (
                            <FactibilidadDetalle
                                factibilidad={factibilidad}
                                cliente={cliente}
                                domicilio={domicilio}
                                artefactos={artefactos}
                                precios={precios}
                                muestraForm={muestraForm}
                            />
                        )}
                    </>
                )
            }
        </div>
    );
}


